import { usePageTitle } from "@/hooks/usePageTitle";
import { useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Loader2, CreditCard, ShieldCheck } from "lucide-react";

export default function TestPayment() {
  usePageTitle("£1 Payment Test");
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);

  const pay = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/payments/checkout", {
        plan: "livetest",
        email,
        origin_url: window.location.origin,
      });
      window.location.href = data.url;
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail) || "Could not start the test payment");
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#F5F5F4] flex items-center justify-center px-6">
      <div className="w-full max-w-md bg-white border border-[#E7E5E4] rounded-2xl p-8 shadow-sm" data-testid="test-payment-page">
        <div className="w-12 h-12 rounded-xl bg-teal/10 text-teal flex items-center justify-center"><CreditCard className="w-6 h-6" /></div>
        <h1 className="mt-4 font-heading text-2xl text-navy">£1 live payment test</h1>
        <p className="mt-2 text-sm text-[#57534E] leading-relaxed">
          Internal page for verifying Stripe payments end-to-end. This charges a real £1 when a live
          Stripe key is configured — refund it afterwards from the Stripe dashboard.
        </p>
        <form onSubmit={pay} className="mt-5 space-y-4">
          <input data-testid="test-payment-email" type="email" required placeholder="Email for the receipt" value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full border border-[#E7E5E4] rounded-lg px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-teal/20 focus:border-teal" />
          <button data-testid="test-payment-submit" type="submit" disabled={busy}
            className="w-full bg-navy text-white hover:bg-navy-dark transition-colors rounded-full py-3 font-medium flex items-center justify-center gap-2 disabled:opacity-60">
            {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <ShieldCheck className="w-4 h-4" />} Pay £1 test via Stripe
          </button>
        </form>
        <p className="mt-4 text-xs text-[#A8A29E]">Test transactions are excluded from your admin revenue figures.</p>
      </div>
    </div>
  );
}
